
import links from '~/data/footer-links.json'

export default

	data: -> linkColumns: links

